//
//  SDKWorkspaceSubscriptionsStatus.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Workspace subscription status enum
export var WorkspaceSubscriptionStatus;
(function (WorkspaceSubscriptionStatus) {
    /** The subscription is active */
    WorkspaceSubscriptionStatus["active"] = "active";
    /** The subscription is on a grace period */
    WorkspaceSubscriptionStatus["gracePeriod"] = "gracePeriod";
    /** The subscription is cancelled */
    WorkspaceSubscriptionStatus["cancelled"] = "cancelled";
    /** The subscription is suspended */
    WorkspaceSubscriptionStatus["suspended"] = "suspended";
})(WorkspaceSubscriptionStatus || (WorkspaceSubscriptionStatus = {}));
